"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MemberAndSale = exports.PriceSaleStyled = exports.PriceMemberAmountStyled = exports.PriceMemberStyled = exports.PriceTextFinalStyled = exports.PriceFinalStyled = exports.PriceTextOldStyled = exports.PriceOldStyled = exports.PriceTextRegularStyled = exports.PriceRegularStyled = exports.PriceBasicStyles = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  ", ",\n  ", " {\n    display: none;\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 700;\n  margin-right: 10px;\n  ", ";\n  font-size: ", ";\n  display: block;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 300;\n  margin-right: 10px;\n  ", ";\n  font-size: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 300;\n  margin-right: 10px;\n  ", ";\n  font-size: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 700;\n  margin-right: 10px;\n  ", ";\n  font-size: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 300;\n  margin-right: 10px;\n  ", ";\n  font-size: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: line-through;\n  color: ", ";\n  font-weight: 300;\n  margin-right: 10px;\n  ", ";\n  font-size: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  ", ";\n  font-size: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  ", ";\n  font-size: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  line-height: 22px;\n  font-size: ", ";\n  ", " {\n    line-height: 16px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PriceBasicStyles = (0, _uiKit.css)(_templateObject(), _uiKit.TextSize.sm, _uiKit.GridBreakpointsMediaDown.md);
exports.PriceBasicStyles = PriceBasicStyles;
var PriceRegularStyled = (0, _uiKit.styled)('span')(_templateObject2(), _uiKit.Colors.gray800, PriceBasicStyles, _uiKit.TextSize.xs);
exports.PriceRegularStyled = PriceRegularStyled;
var PriceTextRegularStyled = (0, _uiKit.styled)('span')(_templateObject3(), _uiKit.Colors.gray800, PriceBasicStyles, _uiKit.TextSize.xxs);
exports.PriceTextRegularStyled = PriceTextRegularStyled;
var PriceOldStyled = (0, _uiKit.styled)('span')(_templateObject4(), _uiKit.Colors.gray500, PriceBasicStyles, _uiKit.TextSize.xs);
exports.PriceOldStyled = PriceOldStyled;
var PriceTextOldStyled = (0, _uiKit.styled)('span')(_templateObject5(), _uiKit.Colors.gray500, PriceBasicStyles, _uiKit.TextSize.xxs);
exports.PriceTextOldStyled = PriceTextOldStyled;
var PriceFinalStyled = (0, _uiKit.styled)('span')(_templateObject6(), _uiKit.Colors.primary, PriceBasicStyles, _uiKit.TextSize.xs);
exports.PriceFinalStyled = PriceFinalStyled;
var PriceTextFinalStyled = (0, _uiKit.styled)('span')(_templateObject7(), _uiKit.Colors.primary, PriceBasicStyles, _uiKit.TextSize.xxs);
exports.PriceTextFinalStyled = PriceTextFinalStyled;
var PriceMemberStyled = (0, _uiKit.styled)('span')(_templateObject8(), _uiKit.Colors.primary, PriceBasicStyles, _uiKit.TextSize.xxs);
exports.PriceMemberStyled = PriceMemberStyled;
var PriceMemberAmountStyled = (0, _uiKit.styled)('span')(_templateObject9(), _uiKit.Colors.primary, PriceBasicStyles, _uiKit.TextSize.xs);
exports.PriceMemberAmountStyled = PriceMemberAmountStyled;
var PriceSaleStyled = (0, _uiKit.styled)('span')(_templateObject10());
exports.PriceSaleStyled = PriceSaleStyled;
var MemberAndSale = (0, _uiKit.styled)('span')(_templateObject11(), PriceMemberStyled, PriceMemberAmountStyled);
exports.MemberAndSale = MemberAndSale;